import { useIsEdjPilotAdvisor } from './use-edj-pilot-advisor';
import { useIsGenworthMode } from '@/features/genworth/hooks/use-genworth-mode';

/**
 * Partner programs that pin the advisor's organization name to a fixed value.
 * Returns the partner label to show in the "preset" tooltip, or null when the
 * org name is editable.
 */
export function useLockedOrgLabel(): string | null {
  const isEdjPilot = useIsEdjPilotAdvisor();
  const isGenworthMode = useIsGenworthMode();

  if (isEdjPilot) return 'the Edward Jones pilot';
  if (isGenworthMode) return 'Genworth';
  return null;
}
